<template>
  <div id="app">
    <div class="loadingBox" :class="{ loadingOff: isLoaded() }">
    <!--
      <img src="/img/loading.svg" style="margin-top: -48px; width: 96px; height: 96px; display: block; filter: blur(0px);" />
    -->
    </div>
    <router-view />
  </div>
</template>

<script>
import enumMixin from '@/concern/enumMixin'
import constMixin from '@/concern/constMixin'
import { WinnersApi, EventCalendarsApi } from './api/'
// import OpeningUtil from '@/util/OpeningUtil'
import { mapActions } from 'vuex'
import moment from 'moment-timezone'
moment.locale('ja', {
  weekdays: ['日曜日', '月曜日', '火曜日', '水曜日', '木曜日', '金曜日', '土曜日'],
  weekdaysShort: ['日', '月', '火', '水', '木', '金', '土']
})

export default {
  mixins: [enumMixin, constMixin], // Enum値, const値の読み込み
  name: 'App',
  components: {
  },
  data () {
    return {
      isDataLoaded: false,
      isFontLoaded: false,
      fontLoopCount: 0
    }
  },
  methods: {
    ...mapActions([
      'setWinners',
      'setEventCalendars',
      'setSpecialExhibitions',
      'setSpecialExhibition',
      'setTsvCompleteFlag',
      'setAreas'
    ]),
    isLoaded () {
      return (this.isDataLoaded && this.isFontLoaded)
    },
    initAreas (winners) {
      const areas = []
      let keepName = null
      for (const winner of winners) {
        if (winner.awardType !== this.EnumAwardTypeJapan100Views) continue
        const areaName = this.prefecturesMap[winner.mainImageTitle]
        if (keepName !== areaName) {
          areas.push({
            id: winner.id,
            name: areaName
          })
          keepName = areaName
        }
      }
      this.setAreas(areas)
    }
  },
  async created () {
    // 開催判定開始 -------------------------------
    // 開催後はコメントアウト
    // const ret = await OpeningUtil.check()
    // if (!ret) {
    //   location.href = '/teaser.html' // 開催していない場合は、ティーザーサイトを表示する
    //   return
    // }
    // 開催判定終了 -------------------------------

    // 読み込み後のloading画面OFF処理
    this.$store.subscribe((mutation) => {
      if (mutation.type === 'setWinners') {
        this.isDataLoaded = true
      }
    })

    // webフォントが読み込まれたかを判定するループ処理
    const id = setInterval(() => {
      this.fontLoopCount++
      if (this.fontLoopCount >= 10) { // 300 * 10 = 3000ms経ったら自動的にフォントは読み込み完了とする
        this.isFontLoaded = true
        clearInterval(id)
      }
      const className = document.getElementsByTagName('html')[0].className
      if (className) {
        this.isFontLoaded = (className.indexOf('wf-active') >= 0)
      }
    }, 300)

    // 受賞カテゴリ毎に設定される空白オブジェクトの雛形
    const spacer = {
      id: this.spacerId, // 空白用のIDを設定
      awardType: this.spacerAwardTypeId, // 空白用の受賞タイプを設定
      name: 'none',
      winningWorks: []
    }

    // 初期データをs3より読み込み
    // 初期データは基本的にwinnersテーブルの中身のみ配列として呼ばれる
    // 各ページでは、足りないデータを逐次読み込むことによって、データを補っていく
    // 例えば、 winners[3].winnerIntroduction === null であったら、winnerIntroduction取得APIを叩く
    // のような感じで、どんどん、winnersにデータを追加する
    if (!['/forbidden', '/not-found', '/internal-server-error', '/bad-gateway', '/maintenance'].includes(this.$route.path)) {
      WinnersApi.getWinners().then((result) => {
        // winnersデータを読み込んだまま使用せず、空白オブジェクトを設定する
        const tempWinners = []
        let isTwitterChanged = false
        let winners = []
        let keepAwardType = null // キーブレイク用
        let spacerId = this.spacerPageInitialIndex
        for (const winner of result) {
          // ■TwitterポスターとTwitterスナップを入れ替える処理開始
          if (winner.awardType === this.EnumAwardTypeTwitterPoster) {
            tempWinners.push(winner) // Twitterポスターのデータは一時的に溜めておく
            continue
          } else if (winner.awardType === this.EnumAwardTypeTwitterPortrait && !isTwitterChanged) {
            winners = winners.concat(tempWinners);
            isTwitterChanged = true
          }
          // ■TwitterポスターとTwitterスナップを入れ替える処理終了

          // swipeでスライドできる範囲のまとめを設定する
          // 10選は一まとまりにするため、awardTypeSwipeCategoryを使ってチェック
          const key = this.awardTypeSwipeCategory[winner.awardType]
          if (key !== keepAwardType) {
            // 受賞区分が変わる度にダミーの空白オブジェクトを設定する
            winners.push({ ...spacer, id: spacerId })
            keepAwardType = key
          }
          winners.push(winner)
          spacerId += 100 // 空白オブジェクト用のIDをインクリメント
        }
        // 最後尾にも空白オブジェクトを追加
        winners.push({ ...spacer, id: spacerId })
        this.setWinners(winners)
        this.initAreas(result)
      }).catch((error) => {
        console.error(error)
      })
      
      // イベントカレンダーデータ読み込み
      EventCalendarsApi.getEventCalendars().then((result) => {
        this.setEventCalendars(result)
      }).catch((error) => {
        console.error(error)
      })
    } else {
      // 初期データを読み込まないページの場合、読み込み完了フラグをtrueとしておく
      this.isDataLoaded = true
      this.isFontLoaded = true
    }
  }
}
</script>

<style scoped>
.loadingBox {
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  opacity: 1;
  transition: all 0.5s;
  z-index: 65535;
}

.loadingOff {
  opacity: 0;
  visibility: hidden;
}

.loadingNone {
  display: none;
}
</style>
